import { type QueryClient, skipToken, useQuery } from '@tanstack/react-query';
import type { ParsedInsightsFilters } from '@/common/api/types/dashboard/filters';
import type { VarianceGroupBy } from '@/common/api/types/dashboard/variance';
import { useOrgId } from '@/common/hooks/useOrgId';
import { VarianceApi } from '@/features/insights-dashboard/api/variance';
import { INSIGHTS_STALE_TIME } from '@/features/insights-dashboard/components/data/constants';
import { insightsQueryKeys } from '@/features/insights-dashboard/queryKeys';

export const invalidateVarianceBreakdown = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: insightsQueryKeys.variance.all() });
};

export const useVarianceBreakdown = ({
  filters,
  scopeItemId,
  loopId,
  groupBy,
  enabled = true,
}: {
  filters: ParsedInsightsFilters;
  scopeItemId?: number;
  loopId: number;
  groupBy: VarianceGroupBy[];
  enabled?: boolean;
}) => {
  const orgId = useOrgId();

  return useQuery({
    queryKey: insightsQueryKeys.variance.breakdown({
      filters,
      scopeItemId,
      loopId,
      orgId,
      groupBy,
    }),
    queryFn:
      groupBy.length > 0
        ? () =>
            VarianceApi.getVarianceBreakdown({
              filters,
              scopeItemId,
              loopId,
              groupBy,
            })
        : skipToken,
    enabled,
    staleTime: INSIGHTS_STALE_TIME,
    retry: false,
  });
};
